// ==============================|| OVERRIDES - LIST ||============================== //

export default function List(theme) {
  return {
    MuiList: {
      styleOverrides: {
        root: {
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1)
        }
      }
    }
  };
}
